import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AdminService } from '../services/admin.service';
import { ROUTES } from '../shared/constants';

export const loginGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const adminService = inject(AdminService);
  const router = inject(Router);
  if (authService.accessToken) {
    router.navigate(['/']);
    return false;
  }
  if (adminService.accessToken) {
    router.navigate([ROUTES.ADMIN.DASHBOARD]);
    return false;
  }
  return true;
};
